import { createApp } from 'vue';
import type { ComponentPublicInstance } from 'vue';
import App from '@/apps/MainApp.vue';
import vuetify from '@/plugins/vuetify';
import i18n from '@/plugins/i18n';
import '@/plugins/log';
import '@/assets/styles.css';
import store from '@/store';
import Matomo from '@/plugins/matomo';
import { guideErrorMessage } from '@/api/mainApi';

const app = createApp(App);

// Catch Vue render/setup errors that never reach axios or a local try/catch
app.config.errorHandler = (err, instance: ComponentPublicInstance | null, info) => {
  const component =
    (instance?.$options?.name as string | undefined) ??
    (instance?.$?.type as { name?: string } | undefined)?.name;
  window.log?.error('[Guide] vue.unhandled — Uncaught Vue render or setup error', {
    message: guideErrorMessage(err),
    info,
    component,
    donationGuideVersion: store.state.donationGuideVersion,
    organizationGroupId: store.state.requestSession?.organizationGroup?.id,
    donationId: store.state.donation?.id,
    serialnumber: store.state.donation?.serialnumber,
    currentStep: store.state.currentStep,
  });
};

app.use(store);
app.use(Matomo, {
  url: import.meta.env.VUE_APP_MATOMO_URL || 'https://rapiddata.matomo.cloud/matomo.php',
  siteId: import.meta.env.VUE_APP_MATOMO_SITE_ID || '3',
  isDisabled: !import.meta.env.PROD, // enabled only in production
});

app.use(vuetify);
app.use(i18n.vueI18n);

// expose dayjs as $date to components (used in multiple places)
import dayjs from 'dayjs/esm/index.js';
app.config.globalProperties.$date = dayjs;

app.mount('#app');
